import ArbitrageTransactionDetails from './arbitrage-transaction-details.vue'
export default ArbitrageTransactionDetails
